/** @format */

import { REQUEST_CONTEXT, inject } from '@angular/core';

import { KillSwitches } from '@shared/data-access/interfaces';

interface RequestContext {
  request?: {
    headers?: Record<string, string | string[] | undefined>;
    header?: string | number;
    protocol?: string;
    originalUrl?: string;
    hostname?: string;
    query?: string | number;
    path?: string;
    get?: () => string | number;
  };
  response?: {
    statusCode?: number;
    get?: () => string | number;
    redirect?: (status: number, url: string) => void;
  };
  KILLSWITCHES?: KillSwitches;
  SERVER_PORT?: number;
}

function injectRequestContext(): RequestContext {
  const requestContext = inject<{
    req?: unknown;
    res?: unknown;
    KILLSWITCH?: KillSwitches;
  } | null>(REQUEST_CONTEXT, {
    optional: true,
  });
  const request = requestContext?.req;
  const response = requestContext?.res;
  const KILLSWITCHES = requestContext?.KILLSWITCH;

  return { request, response, KILLSWITCHES };
}

export function injectServerRequest(): RequestContext['request'] {
  const requestContext = injectRequestContext();

  return requestContext?.request;
}

export function injectServerResponse(): RequestContext['response'] {
  const requestContext = injectRequestContext();

  return requestContext?.response;
}

export function injectServerRequestKillSwitches(): RequestContext['KILLSWITCHES'] | null {
  const requestContext = injectRequestContext();

  return requestContext?.KILLSWITCHES ?? null;
}
